import React from "react";

function Order({ colorCode = "" }) {
  return (
    <svg
      className="MuiSvgIcon-root"
      viewBox="0 0 20 20"
      fill={colorCode}
      style={{ fill: "transparent" }}
    >
      <rect
        x="1"
        y="2"
        width="18"
        height="16"
        rx="2"
        stroke={colorCode}
        strokeWidth="2"
      />
      <path
        d="M4 6.5C4 7.88071 5.11929 9 6.5 9C7.88071 9 9 7.88071 9 6.5C9 5.11929 7.88071 4 6.5 4C5.11929 4 4 5.11929 4 6.5ZM5.25 6.5C5.25 5.80964 5.80964 5.25 6.5 5.25C7.19036 5.25 7.75 5.80964 7.75 6.5C7.75 7.19036 7.19036 7.75 6.5 7.75C5.80964 7.75 5.25 7.19036 5.25 6.5Z"
        fill={colorCode}
      />
      <path
        d="M11 6.5C11 7.88071 12.1193 9 13.5 9C14.8807 9 16 7.88071 16 6.5C16 5.11929 14.8807 4 13.5 4C12.1193 4 11 5.11929 11 6.5ZM12.25 6.5C12.25 5.80964 12.8096 5.25 13.5 5.25C14.1904 5.25 14.75 5.80964 14.75 6.5C14.75 7.19036 14.1904 7.75 13.5 7.75C12.8096 7.75 12.25 7.19036 12.25 6.5Z"
        fill={colorCode}
      />
      <path
        d="M4 13.5C4 14.8807 5.11929 16 6.5 16C7.88071 16 9 14.8807 9 13.5C9 12.1193 7.88071 11 6.5 11C5.11929 11 4 12.1193 4 13.5ZM5.25 13.5C5.25 12.8096 5.80964 12.25 6.5 12.25C7.19036 12.25 7.75 12.8096 7.75 13.5C7.75 14.1904 7.19036 14.75 6.5 14.75C5.80964 14.75 5.25 14.1904 5.25 13.5Z"
        fill={colorCode}
      />
      <path
        d="M14.125 11H12.875V12.875H11V14.125H12.875V16H14.125V14.125H16V12.875H14.125V11Z"
        fill="#51CBFF"
      />
    </svg>
  );
}

export default Order;
